var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    [
      _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-md": "" } },
        [
          _c(
            "v-card",
            { staticClass: "px-2 py-2" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c("v-flex", { staticClass: "flex-column" }, [
                            _c(
                              "h2",
                              {
                                staticClass: "h2_title",
                                staticStyle: { "margin-top": "12px !important" }
                              },
                              [
                                _vm._v(
                                  "\n                Asignación Mandante OWL\n              "
                                )
                              ]
                            ),
                            _c("div", [_vm._v("Vehículo | Mandante")])
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { staticClass: "flex-column" },
                        [_c("Asignacion", { ref: "asignacion" })],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }